Object.defineProperty(exports, '__esModule', { value: true });

const tslib_es6 = require('../../ext/tslib/tslib.es6.js');
const browser = require('../../../../ext/fflate/esm/browser.js');
const base = require('./base.js');

var pack = function (event) {
    var _e = tslib_es6.__assign(tslib_es6.__assign({}, event), { v: base.MARK });
    return browser.strFromU8(browser.zlibSync(browser.strToU8(JSON.stringify(_e))), true);
};

exports.pack = pack;
//# sourceMappingURL=pack.js.map
